import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { getRoomById } from '../api/rooms'
import { makeImageUrl } from '../utils/media'

export default function AnnonceView() {
  const { id } = useParams()
  const [item, setItem] = React.useState(null)
  const [err, setErr] = React.useState(null)

  React.useEffect(() => {
    getRoomById(id).then((r)=>{
      // map images
      const imgs = Array.isArray(r.imageUrl) ? r.imageUrl.map(makeImageUrl) : [makeImageUrl(r.image)]
      setItem({ ...r, imageUrl: imgs.filter(Boolean) })
    }).catch(e=>setErr('Annonce introuvable'))
  }, [id])

  if (err) return <div className="section"><div className="container mx-auto px-4">{err}</div></div>
  if (!item) return <div className="section"><div className="container mx-auto px-4">Chargement…</div></div>

  return (
    <section className="section">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="grid gap-3">
            {item.imageUrl?.map((src, i)=>(
              <img key={i} src={src} alt={item.name || item.title} className="w-full rounded-2xl border border-blue-100" />
            ))}
          </div>

          <div>
            <h1 className="text-3xl font-extrabold">{item.title || item.name}</h1>
            <p className="text-muted">
              {item.location?.street} {item.location?.district && '· ' + item.location?.district} {item.location?.city && '· ' + item.location?.city}
            </p>

            <div className="mt-3 text-xl font-extrabold">
              {item.price?.amount} {item.price?.currency} {item.price?.unit && <span className="text-muted text-base">/ {String(item.price.unit).replace('Per','').toLowerCase()}</span>}
            </div>

            <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
              <li><strong>Invités max:</strong> {item.maxGuests ?? '-'}</li>
              <li><strong>Lits:</strong> {item.bedCount ?? '-'}</li>
              <li><strong>Pièces:</strong> {item.roomsCount ?? '-'}</li>
              <li><strong>Surface:</strong> {item.sizeInSquareMeters ?? '-'} m²</li>
              <li><strong>Salle de bain privée:</strong> {item.hasPrivateBathroom ? 'Oui' : 'Non'}</li>
            </ul>

            <p className="mt-4">{item.description}</p>

            <div className="mt-6 flex gap-3">
              <Link className="btn btn-primary" to="/contact">Contacter</Link>
              <Link className="btn btn-ghost" to="/annonces">Retour</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
